import type { HelpCenterCategory } from '@ps/web-martech-cms-types';

import { Header } from '@swf/core/enums';
import type { WidgetEffectParams } from '@swf/core/store';
import { pageChange } from '@swf/core/utils/actions';
import type { ArticlesList, Category } from '@swf/help';

import type { WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(
    _payload: undefined,
    { dispatch, widget, select, rootState, actions }: WidgetEffectParams<HelpCenterCategory>
  ) {
    const { dataRequested, clear }: WidgetDispatch = dispatch[widget.uid];
    const { hasPreloaded }: WidgetSelect = select[widget.uid];

    pageChange(actions)?.subscribe(() => dataRequested(false));
    widget.unmount.subscribe(clear);

    if (!hasPreloaded(rootState)) {
      await dataRequested();
    }
  },

  async dataRequested(fetchCategories = true, params: WidgetEffectParams<HelpCenterCategory>) {
    const { dispatch, request, select, widget, rootState } = params;
    const { pageSize }: WidgetSelect = select[widget.uid];
    const { category } = select.cms.getUrlParams(rootState);
    const { isBot } = select.help.get(rootState);

    try {
      const [articlesList, categories] = await Promise.all([
        request<ArticlesList>({
          service: 'help.articlesByCategoryId',
          body: { category, size: pageSize }
        }),
        fetchCategories
          ? request<Category[]>({
              service: 'help.categoryList',
              headers: {
                [Header.Bot]: isBot ? '1' : '0'
              }
            })
          : undefined
      ]);

      dispatch[widget.uid].dataLoadSuccess({
        ...(fetchCategories && { categoriesList: categories?.body || [] }),
        articlesList: articlesList?.body || { articles: [] }
      });
    } catch (error) {
      dispatch[widget.uid].dataLoadFailed();
    }
  }
};
